import React from 'react';

// Inline external citation link. Plain underline at rest; on hover the
// underline cycles through the project's 5 rainbow colours (the text
// itself stays body-coloured). Used inline in body text — see /info,
// /reading, etc.
//
// Styling lives in pages/Info.css under .info-cite. Since the Reading
// page also imports Info.css for layout, no duplication needed.
export default function Cite({ href, children }) {
  return (
    <a className="info-cite" href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}
